import {
  Box,
  Button,
  Chip,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { ClipConfiguration } from "../../models";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import { makeStyles } from "@mui/styles";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import dayjs from "dayjs";

interface ClipItemProps {
  clip: ClipConfiguration;
  onClick: (clip: ClipConfiguration) => void;
}

export const ClipItem = (props: ClipItemProps) => {
  const classes = useStyles();

  return (
    <Paper variant="outlined" className={classes.item}>
      <Paper elevation={0} square className={classes.photo}>
        <PhotoOutlinedIcon fontSize="large" />
      </Paper>
      <Grid
        gap={1}
        display="flex"
        flexDirection="row"
        padding={1}
        justifyContent="space-between"
        width="298px"
      >
        <Grid display="flex" flexDirection="column">
          <Typography variant="subtitle1" noWrap>
            {props.clip.name}
          </Typography>
          <Stack spacing={1} direction="row" alignItems="center">
            <AccountBoxIcon color="action"></AccountBoxIcon>
            <Typography variant="body2">{props.clip.developer}</Typography>
          </Stack>
          <Stack spacing={1} direction="row" alignItems="center">
            <CalendarTodayIcon color="action"></CalendarTodayIcon>
            <Typography variant="subtitle2">
              {dayjs.utc(props.clip.date).local().format("YYYY-MM-DD")}
            </Typography>
          </Stack>
        </Grid>
        <Stack spacing={1} direction="column" justifyContent="space-between">
          <Chip
            size="small"
            label={props.clip.status.toUpperCase()}
            variant="outlined"
          />
          <Button
            size="small"
            variant="text"
            onClick={() => props.onClick(props.clip)}
          >
            Open
          </Button>
        </Stack>
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles((theme: any) => ({
  photo: {
    width: "100px",
    height: "100px",
    textAlign: "center",
    alignContent: "center",
    backgroundColor: theme.palette.action.hover,
  },
  item: {
    width: "398px",
    height: "100px",
    display: "flex",
    flexDirection: "row",
    gap: 1,
  },
}));
